import React from 'react';

export interface SelectProps<T extends string | number> {
  value: T | '';
  options: { value: T; label: string }[];
  onChange: (v: T) => void;
  'aria-label'?: string;
  className?: string;
  disabled?: boolean;
  /** まだ何も選んでいない（value が ''）ときだけ先頭に出す案内の行 */
  placeholder?: string;
}

/**
 * 端末の標準の選び方を使うプルダウン。TaskySelect は旧画面の見た目（Tailwind）なので、新UIはこれを使う。
 * 見た目は呼ぶ側の className で決める。
 */
export function Select<T extends string | number>({ value, options, onChange, className, disabled, placeholder, 'aria-label': ariaLabel }: SelectProps<T>) {
  return (
    // eslint-disable-next-line no-restricted-syntax -- 新UIの共通部品の select（上の説明）
    <select
      className={className}
      aria-label={ariaLabel}
      value={String(value)}
      disabled={disabled}
      onChange={(e) => {
        const hit = options.find((o) => String(o.value) === e.target.value);
        if (hit) onChange(hit.value);
      }}
    >
      {value === '' && placeholder !== undefined && <option value="">{placeholder}</option>}
      {options.map((o) => (
        <option key={String(o.value)} value={String(o.value)}>
          {o.label}
        </option>
      ))}
    </select>
  );
}
